import { useEffect } from "react";
// import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { getFlagById, getFlaggedDataColumns } from "../../../../services/flag";
import { errorMsg } from "../../../../utils/vars";
// import { setBackButtonRoute, useGetBackButtonRoute } from "../../../../redux/features/flagDetailsBackButtonRoute";

const useFlagsDetailsAdvancedSearch = () => {
  const { id } = useParams();
  // const dispatch = useDispatch();
  // const backButtonRoute = useGetBackButtonRoute();

  const {
    data: flagData,
    isLoading: isLoadingFlagData,
    isFetching: isFetchingFlagData,
    error: flagDataError,
  } = useQuery({
    queryKey: ["flag-details-advanced-search", id],
    queryFn: () => getFlagById(id),
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  const {
    data: columnsData,
    isLoading: isLoadingColumnsData,
    error: columnsDataError,
  } = useQuery({
    queryKey: ["flag-details-advanced-search-columns", id],
    queryFn: () => getFlaggedDataColumns(id),
    retry: 1,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (flagDataError) {
      toast.error(flagDataError?.response?.data?.message || errorMsg);
    }
  }, [flagDataError]);

  useEffect(() => {
    if (columnsDataError) {
      toast.error("Can't get flagged data. Try again later.");
    }
  }, [columnsDataError]);

  // useEffect(() => {
  //   return () => {
  //     dispatch(setBackButtonRoute(null));
  //   };
  // }, [dispatch]);

  return {
    id,
    flagData,
    columnsData,
    // backButtonRoute,
    isLoading: isLoadingFlagData || isLoadingColumnsData || isFetchingFlagData,
    flagDataError,
    columnsDataError,
  };
};

export default useFlagsDetailsAdvancedSearch;
